(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["color-selected"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var colorCircles = document.querySelectorAll('.color-circle');
    var productImage = document.getElementById('product-image');

    colorCircles.forEach(function (circle) {
      circle.addEventListener('mouseover', function () {
        var newImage = this.getAttribute('data-image');
        productImage.src = newImage;
      });
    });
  });

  // Fonction pour calculer la luminosité d'une couleur
  function getLuminance(color) {
    // Convertir la couleur en RGB
    const rgb = color.match(/\d+/g).map(Number);
    // Calculer la luminosité selon la formule ITU-R BT.709
    const luminance = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
    return luminance;
  }

  // Fonction pour calculer la luminosité d'une couleur
  function getLuminance(color) {
    // Convertir la couleur en RGB
    const rgb = color.match(/\d+/g).map(Number);
    // Calculer la luminosité selon la formule ITU-R BT.709
    const luminance = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
    return luminance;
  }

  // Fonction pour mettre à jour la couleur du texte en fonction de la couleur de fond
  function updateTextColorOnHover() {
    // Sélectionner tous les éléments avec la classe color-circle
    const colorCircles = document.querySelectorAll('.color-circle');

    colorCircles.forEach((circle) => {
      // Obtenir la couleur de fond de l'élément
      const backgroundColor = window.getComputedStyle(circle).backgroundColor;
      // Calculer la luminosité de la couleur de fond
      const luminance = getLuminance(backgroundColor);
      // Définir la couleur du texte en fonction de la luminosité
      const textColor = luminance > 0.5 ? 'black' : 'white';

      // Ajouter un gestionnaire d'événement pour le survol
      circle.addEventListener('mouseenter', function () {
        circle.querySelector('.variant-title').style.color = textColor;
      });

      // Ajouter un gestionnaire d'événement pour la fin du survol
      circle.addEventListener('mouseleave', function () {
        circle.querySelector('.variant-title').style.color = 'transparent';
      });

      circle.addEventListener('click', function () {
        // GET Attr data-url
        const url = this.getAttribute('data-url');
        // Redirect to the URL
        window.location.href = url;
      });
    });
  }

  // Appeler la fonction au chargement de la page
  document.addEventListener('DOMContentLoaded', updateTextColorOnHover);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-list-matieres"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const filterCheckboxes = document.querySelectorAll('.facets__label input[type="checkbox"]');
    const resetButtons = document.querySelectorAll('.facets__reset');

    filterCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', function () {
        const selectedValues = Array.from(filterCheckboxes)
          .filter((checkbox) => checkbox.checked)
          .map((checkbox) => checkbox.value);

        document.querySelectorAll('.material-entry').forEach((card) => {
          if (selectedValues.length === 0 || selectedValues.includes(card.dataset.material)) {
            card.style.display = 'block';
          } else {
            card.style.display = 'none';
          }
        });

        updateSelectedCount();
      });
    });

    resetButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        filterCheckboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
        document.querySelectorAll('.material-entry').forEach((card) => {
          card.style.display = 'block';
        });
        updateSelectedCount();
      });
    });

    function updateSelectedCount() {
      document.querySelectorAll('.facets__disclosure').forEach((disclosure) => {
        const selectedCount = disclosure.querySelectorAll('input[type="checkbox"]:checked').length;
        const selectedText = disclosure.querySelector('.facets__selected');
        selectedText.textContent = `${selectedCount} sélectionné${selectedCount > 1 ? 's' : ''}`;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-materiautheque"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const alphabetLinks = document.querySelectorAll('.alphabet-navigation a');
    const materiautheque = document.querySelector('.materiautheque');

    function updateActiveLink() {
      const scrollPosition = materiautheque.scrollTop + materiautheque.clientHeight / 2;
      let activeLetter = '';

      document.querySelectorAll('.material-item').forEach((item) => {
        const itemTop = item.offsetTop;
        const itemBottom = itemTop + item.clientHeight;

        if (scrollPosition >= itemTop && scrollPosition < itemBottom) {
          activeLetter = item.getAttribute('id');
        }
      });

      alphabetLinks.forEach((link) => {
        link.classList.toggle('active', link.getAttribute('href').substring(1) === activeLetter);
      });
    }

    materiautheque.addEventListener('scroll', updateActiveLink);

    alphabetLinks.forEach((link) => {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        materiautheque.scrollTo({
          top: targetElement.offsetTop,
          behavior: 'smooth',
        });
      });
    });

    function initializeCarousels() {
      document.querySelectorAll('.material-gallery').forEach((gallery) => {
        const carousel = gallery.querySelector('.carousel');
        const items = carousel.querySelectorAll('.carousel-item');
        const dotsContainer = gallery.querySelector('.slider-dots');
        let currentIndex = 0;

        // Créer les points de navigation
        items.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.addEventListener('click', () => showSlide(index));
          dotsContainer.appendChild(dot);
        });

        function updateCarousel() {
          const offset = -currentIndex * 100;
          items.forEach((item) => {
            item.style.transform = `translateX(${offset}%)`;
          });
          dotsContainer.querySelectorAll('button').forEach((dot, index) => {
            dot.classList.toggle('active', index === currentIndex);
          });
        }

        function showSlide(index) {
          currentIndex = index;
          updateCarousel();
        }

        // Initialiser le carousel
        updateCarousel();
      });
    }

    initializeCarousels();
    updateActiveLink(); // Initial call to set the active link based on initial scroll position
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1070px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener("DOMContentLoaded", function () {
    // Récupérer les éléments
    const cartIconBubble = document.getElementById("cart-icon-bubble");
    const subCart = document.getElementById("subCart");

    // Fonction pour afficher ou cacher la div subCart
    function toggleSubCart() {
        if (subCart.style.display === "none" || subCart.style.display === "") {
            subCart.style.display = "block";
        } else {
            subCart.style.display = "none";
        }
    }

    // Fonction pour cacher la div subCart
    function hideSubCart() {
        subCart.style.display = "none";
    }

    // Afficher la div subCart quand on clique sur le bouton
    cartIconBubble.addEventListener("click", function (event) {
        event.stopPropagation(); // Empêche la propagation du clic
        toggleSubCart();
    });

    // Cacher la div subCart quand on clique ailleurs
    document.addEventListener("click", function (event) {
        // Vérifie si le clic est à l'extérieur de la div subCart
        if (!subCart.contains(event.target) && event.target !== cartIconBubble) {
            hideSubCart();
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    async function addLinkedBox(productKey, linkedProductId, quantity) {
      try {
        const payload = {
          id: linkedProductId,
          quantity: quantity,
          properties: {
            _linkedToParent: productKey,
            _linkedProduct: true,
            _AddByCountry: true,
          },
        };

        console.log(`Ajout de la caisse liée pour le produit ${productKey} avec quantité ${quantity}`);
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        console.log(`Caisse ajoutée avec la propriété _AddByCountry pour le produit ${productKey}`);
        window.location.reload();
      } catch (error) {
        console.error("Erreur lors de l'ajout de la caisse liée :", error);
      }
    }

    async function updateLinkedBoxToFalse(productKey, quantity) {
      try {
        const payload = {
          id: productKey,
          quantity: quantity,
          properties: {
            _AddByCountry: 'false',
            _linkedProduct: 'true',
            _linkedToParent: productKey,
          },
        };

        console.log(`Mise à jour _AddByCountry pour produit ${productKey}`, payload);

        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          const errorData = await response.json();
          console.error('Erreur update caisse liée :', errorData);
          return;
        }

        console.log(`_AddByCountry mis à jour avec succès pour le produit ${productKey}`);
      } catch (error) {
        console.error('Erreur mise à jour caisse liée :', error);
      }
    }

    async function updateAddByCountryFlag(linkedItemKey, value, quantity) {
      try {
        const payload = {
          id: linkedItemKey,
          quantity: quantity,
          properties: {
            _linkedProduct: true,
            _AddByCountry: value ? 'true' : '',
          },
        };

        console.log(`🔁 Mise à jour _AddByCountry=${value} pour ${linkedItemKey}`);

        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          const errorData = await response.json();
          console.error('❌ Erreur update _AddByCountry :', errorData);
        } else {
          console.log(`✅ _AddByCountry mis à jour pour ${linkedItemKey}`);
        }
      } catch (error) {
        console.error('❌ Erreur lors de la mise à jour _AddByCountry :', error);
      }
    }

    async function handleLinkedCrates(isBoxRequired) {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        const productNoBoxItems = document.querySelectorAll(
          'tr.product-no-box:not(.product-without-box, .product-width-box-required)'
        );

        let shouldReload = false;

        for (const productRow of productNoBoxItems) {
          const productKey = productRow.dataset.itemKey;
          if (!productKey) continue;

          const linkedProduct = linked_products[productKey];
          if (!linkedProduct) continue;

          const parentItem = cart.items.find((item) => item.key === productKey);
          if (!parentItem) continue;

          // On cherche le produit lié déjà dans le panier
          const linkedItem = cart.items.find(
            (item) =>
              item.properties &&
              item.properties._linkedToParent === productKey &&
              item.properties._linkedProduct === true
          );

          const hasLinkedBox = Boolean(linkedItem);

          if (isBoxRequired) {
            if (!hasLinkedBox) {
              // Ajoute la caisse avec _AddByCountry = true
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: linkedProduct.id,
                  quantity: parentItem.quantity,
                  properties: {
                    _linkedProduct: true,
                    _linkedToParent: productKey,
                    _AddByCountry: 'true',
                  },
                }),
              });
              console.log('🧱 Caisse ajoutée automatiquement (obligatoire)');
              shouldReload = true;
            } else if (linkedItem.properties._AddByCountry !== 'true') {
              // Met à jour la propriété _AddByCountry du produit lié
              await updateAddByCountryFlag(linkedItem.key, true, linkedItem.quantity);
              shouldReload = true;
            }
          } else {
            if (hasLinkedBox && linkedItem.properties._AddByCountry === 'true') {
              // Change le flag _AddByCountry à vide si c'était obligatoire
              await updateAddByCountryFlag(linkedItem.key, false, linkedItem.quantity);
              shouldReload = true;
            }
          }
        }

        if (shouldReload) {
          document.getElementById('country-loader')?.style.setProperty('display', 'flex');
          setTimeout(() => window.location.reload(), 700);
        }
      } catch (error) {
        console.error('❌ Erreur dans handleLinkedCrates :', error);
      }
    }

    function updateProcessButtonState() {
      const submitBtn = document.getElementById('processToOrder');
      const warningMsg = document.getElementById('country-warning-order');
      const selected = document.querySelector('input[name="filter.v.option.country"]:checked');

      if (!selected) {
        if (submitBtn) submitBtn.setAttribute('disabled', 'true');
        if (warningMsg) warningMsg.style.display = 'block';
      } else {
        if (submitBtn) submitBtn.removeAttribute('disabled');
        if (warningMsg) warningMsg.style.display = 'none';
      }
    }

    function initializeCountryListeners() {
      const countryRadios = document.querySelectorAll('input[name="filter.v.option.country"]');
      if (countryRadios.length === 0) return false;

      countryRadios.forEach((radio) => {
        radio.addEventListener('change', async function () {
          const selectedCountry = this.value.trim();
          const isBoxRequired = this.dataset.box === 'true';

          const formData = JSON.parse(localStorage.getItem('QuoteFormData') || '{}');
          const previousCountry = formData.selectedCountry;

          formData.selectedCountry = selectedCountry;
          localStorage.setItem('QuoteFormData', JSON.stringify(formData));

          const hasChanged = previousCountry && previousCountry !== selectedCountry;

          await handleLinkedCrates(isBoxRequired);

          if (hasChanged) {
            console.log('🌍 Le pays a changé, rechargement forcé du panier.');
            document.getElementById('country-loader')?.style.setProperty('display', 'flex');
            setTimeout(() => window.location.reload(), 500);
          }

          updateProcessButtonState();
        });
      });

      updateProcessButtonState();
      return true;
    }

    function initializeCountryListeners() {
      const countryRadios = document.querySelectorAll('input[name="filter.v.option.country"]');
      if (countryRadios.length === 0) return false;

      countryRadios.forEach((radio) => {
        radio.addEventListener('change', async function () {
          const selectedCountry = this.value.trim();
          const isBoxRequired = this.dataset.box === 'true';

          // 🔁 Récupère le pays précédent depuis localStorage
          const formData = JSON.parse(localStorage.getItem('QuoteFormData') || '{}');
          const previousCountry = formData.selectedCountry;

          // 📝 Mets à jour le pays sélectionné
          formData.selectedCountry = selectedCountry;
          localStorage.setItem('QuoteFormData', JSON.stringify(formData));

          // 🔄 Vérifie si le pays a changé
          const hasChanged = previousCountry && previousCountry !== selectedCountry;

          // 🧩 Gère l’ajout ou la mise à jour des caisses
          await handleLinkedCrates(isBoxRequired);

          // 🔁 Recharge la page uniquement si le pays a changé
          if (hasChanged) {
            console.log('🌍 Le pays a changé, rechargement forcé du panier.');
            document.getElementById('country-loader')?.style.setProperty('display', 'flex');
            setTimeout(() => window.location.reload(), 800);
          }

          updateProcessButtonState();
        });
      });

      updateProcessButtonState();
      return true;
    }

    function restoreSelectedCountry() {
      const formData = JSON.parse(localStorage.getItem('QuoteFormData') || '{}');

      if (!formData.selectedCountry) {
        console.log('Aucun pays sélectionné précédemment.');
        document.getElementById('processToOrder')?.setAttribute('disabled', true);
        document.getElementById('country-warning')?.classList.remove('hidden');
        return;
      }

      const selectedCountry = formData.selectedCountry.trim();

      const interval = setInterval(() => {
        const radio = document.querySelector(`input[name="filter.v.option.country"][value="${selectedCountry}"]`);
        if (radio) {
          clearInterval(interval);
          radio.checked = true;
          radio.dispatchEvent(new Event('change')); // on déclenche le comportement lié
          const legendElement = document.querySelector('.facets__summary-label');
          if (legendElement) legendElement.textContent = selectedCountry;

          console.log(`Pays restauré : ${selectedCountry}`);
        }
      }, 200);
    }

    function waitForCountryRadiosThenRestore() {
      const interval = setInterval(() => {
        const radios = document.querySelectorAll('input[name="filter.v.option.country"]');
        if (radios.length > 0) {
          clearInterval(interval);
          initializeCountryListeners();
          restoreSelectedCountry();
        }
      }, 300);
    }
    // Lancement en boucle jusqu'à ce que les pays soient injectés dynamiquement
    window.addEventListener('load', () => {
      waitForCountryRadiosThenRestore();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const track = document.querySelector('.carousel-track');
    const items = document.querySelectorAll('.carousel-item');
    const dots = document.querySelectorAll('.carousel-dots .dot');
    const itemsPerSlide = 3;
    let currentIndex = 0;

    function updateCarousel() {
      const itemWidth = items[0].getBoundingClientRect().width;
      track.style.transform = `translateX(-${currentIndex * itemWidth * itemsPerSlide}px)`;
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
      });
    }

    function nextSlide() {
      if (currentIndex < dots.length - 1) {
        currentIndex++;
      } else {
        currentIndex = 0;
      }
      updateCarousel();
    }

    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
      } else {
        currentIndex = dots.length - 1;
      }
      updateCarousel();
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', function () {
        currentIndex = parseInt(this.dataset.index);
        updateCarousel();
      });
    });

    window.addEventListener('resize', updateCarousel);
    updateCarousel();
    // setInterval(nextSlide, 5000); // Change slide every 5 seconds
  });

  } catch(e) { console.error(e); }
})();
})();
